export default __webpack_public_path__ + "static/media/Microsoft.8187b614.svg";